import * as React from "react";
import { SVGProps } from "react";

const Poet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    viewBox="0 0 466 466"
    {...props}
  >
    <style>{".st0{fill:#393534}.st3{fill:#e1ded9}"}</style>
    <g id="Po.et">
      <g id="Ellipse" transform="translate(-121 -292)">
        <path
          id="path0_fill"
          d="M587 525c0 128.7-104.3 233-233 233S121 653.7 121 525s104.3-233 233-233 233 104.3 233 233z"
          className="st0"
        />
      </g>
      <g id="Ellipse_1_" transform="translate(-119 -290)">
        <path
          id="path1_fill"
          fill="#f2f2f2"
          d="M557.9 525c0 112.6-91.3 203.9-203.9 203.9S150.1 637.6 150.1 525 241.4 321.1 354 321.1 557.9 412.4 557.9 525z"
        />
      </g>
      <g id="poe">
        <g id="Group">
          <g id="Vector" transform="translate(-110.56 -283.616)">
            <path
              id="path2_fill"
              fill="#fff"
              d="M422.7 459.9 276.3 609.6l-3.2-60.3 88.3-89.4 36.6-38 23.7-7.8 17.2 4.5L455 432l-19.4 22.3-12.9 5.6z"
            />
          </g>
          <g id="Shape" transform="translate(-101.969 -282.328)">
            <path
              id="path3_fill"
              d="M427.4 462.8 398.1 493h44.4l5-5.1c3.5-3.6 6.3-8 8.2-12.7 1.9-4.8 2.8-9.9 2.8-15 0-10.2-3.8-19.9-10.6-27.3l-20.2 21c1.1 1.2 1.6 2.9 1.6 4.5-.1 1.6-.8 3.2-1.9 4.4z"
              className="st3"
            />
          </g>
          <g id="Shape_1_" transform="translate(-109.362 -272.234)">
            <path
              id="path4_fill"
              d="m314.4 579.8-23.9 24.8h44.4l24.1-24.8h-44.6z"
              className="st3"
            />
          </g>
          <g id="Shape_2_" transform="translate(-107.056 -274.811)">
            <path
              id="path5_fill"
              d="M324.1 569.8h44.4l26.5-27.5h-44.4l-26.5 27.5z"
              className="st3"
            />
          </g>
          <g id="Shape_3_" transform="translate(-104.571 -277.511)">
            <path
              id="path6_fill"
              d="M433 503h-44.4l-28.4 29.3h44.4L433 503z"
              className="st3"
            />
          </g>
        </g>
        <g id="Shape_4_" transform="translate(-113 -284)">
          <path
            id="path7_fill"
            d="M456.1 423.7c-4.6-4.8-10.1-8.6-16.1-11.2s-12.5-3.9-19-3.9-13 1.3-19 3.9-11.5 6.5-16.1 11.3l-115 118.8c-1.1 1.3-1.8 3-1.7 4.7v61.2l-31.7 33.1h17.4l23.5-24.3h58.8c.8 0 1.6-.1 2.4-.5.7-.3 1.4-.9 1.9-1.5l114.3-118.4.2-.2c9.3-9.7 14.5-22.8 14.4-36.4.1-6.8-1.2-13.5-3.7-19.7-2.3-6.5-6-12.1-10.6-16.9zm-66.8 13.8 5-5.1c7.1-7.3 16.7-11.4 26.7-11.4s19.6 4.1 26.7 11.4c.2.2.2.4.4.4 6.8 7.4 10.6 17.3 10.6 27.6-.1 10.3-4 20.1-11 27.4l-5 5.1h-44.4l29.1-30.2c1.1-1.1 1.8-2.7 1.8-4.3s-.5-3.2-1.6-4.4c-.2-.2-.2-.2-.2-.4-1.1-1.2-2.7-1.8-4.3-1.8-1.6 0-3.2.7-4.3 1.8l-29.5 30.6v-46.7zm-98.8 167.1 23.9-24.8h44.4l-23.9 24.8h-44.4zm69.7-72.3 28.4-29.5H433l-28.4 29.5h-44.4zm34.7 10-26.5 27.5H324l26.5-27.5h44.4zm-43.7-65.4 28.4-29.5v46.7l-28.4 29.5v-46.7zM315 514.4l26.5-27.5v46.7L315 561.1v-46.7zm-33.8 35.1 24.3-25v46.7l-24.3 25"
            className="st0"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Poet;
